import axios from "@/services/axios.config";
import { MethodologyAdditionalInfoResponse } from "@/types/AdditionalInfo";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

export const getMethodologyAdditionalInfo = async (methodologyId: string) =>
	await axios
		.get<APIResponse<MethodologyAdditionalInfoResponse>>("/methodology/detail", {
			params: { id: methodologyId },
		})
		.then((res) => res.data.data)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useGetAdditionalInfo(methodologyId: string | undefined) {
	return useQuery({
		queryKey: ["getAdditionalInfo", methodologyId],
		queryFn: () => getMethodologyAdditionalInfo(methodologyId!),
		enabled: !!methodologyId,
		retry: 0,
		onError: (err: APIResponse) => {
			if (![400, 403, 404].includes(err.httpStatus)) {
				toastOnError(err);
			}
		},
	});
}
